const E={ExternalVideo:"EXTERNAL_VIDEO",Image:"IMAGE",Model_3D:"MODEL_3D",Video:"VIDEO"};export{E as UnlikelyMediaType};
//# sourceMappingURL=media.js.map
